import { FoerderRegime } from "../types/api.types";

const FOERDERREGIMES_REQUIRING_YEAR = [
  FoerderRegime.eeg_ausschreibung,
  FoerderRegime.eeg_innovationsausschreibung_gleitende_marktpraemie,
  FoerderRegime.eeg_innovationsausschreibung_fixe_marktpraemie
];

/** Returns whether the funding regime requires a Jahr des Gebotstermins. */
function getNeedsJahrDesGebotstermins(foerderregime: FoerderRegime): boolean {
  return FOERDERREGIMES_REQUIRING_YEAR.includes(foerderregime);
}

export { getNeedsJahrDesGebotstermins };
